import { IngredientType } from "./enums/ingredient-type.enum";

export abstract class Ingredient {
  public type: IngredientType;
  abstract typeToString(): string;
}
